/**
 * @generated SignedSource<<ccaf0088022739d1179ef3bdd7784f7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditTagScreen_TagFragment$data = {
  readonly colorHex: string;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "EditTagScreen_TagFragment";
};
export type EditTagScreen_TagFragment$key = {
  readonly " $data"?: EditTagScreen_TagFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditTagScreen_TagFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditTagScreen_TagFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "colorHex",
      "storageKey": null
    }
  ],
  "type": "Tag",
  "abstractKey": null
};

(node as any).hash = "c183be6f22d530a0b223b5697980df6a";

export default node;
